export const MICROSOFT_MODEL: ServerDataTypes.Model = {
  name: '微软翻译',
  desc: '',
  version: 'free',
  level: 1,
  type: 'machine',
  key: 'microsoft',
  ai: false,
  translate: true,
  icon: 'https://cdn.yiban.io/web/pt-web/model_logo/microsoft.png',
}

export const DEEPL_MODEL: ServerDataTypes.Model = {
  ai: false,
  translate: true,
  desc: '',
  key: 'deepl-classic',
  level: 2,
  name: 'DeepL',
  type: 'machine',
  version: 'pro',
  icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepl.png',
}

export const GLM_FLASH_MODEL: ServerDataTypes.Model = {
  ai: true,
  desc: '',
  key: 'glm-4-flash',
  level: 1,
  name: '智谱GLM-4-Flash',
  translate: true,
  type: 'ai',
  version: 'free',
  icon: 'https://cdn.yiban.io/web/pt-web/model_logo/zhipu.png',
}

export const DEEPSEEK_R1_MODEL: ServerDataTypes.Model = {
  ai: true,
  desc: '',
  key: 'deepseek-r1',
  level: 2,
  name: 'DeepSeek R1',
  translate: false,
  type: 'ai',
  version: 'pro',
  icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepseek.png',
}

export const DEEPSEEK_V3: ServerDataTypes.Model = {
  ai: true,
  desc: '',
  key: 'deepseek-v3',
  level: 2,
  name: 'DeepSeek V3',
  translate: true,
  type: 'ai',
  version: 'pro',
  icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepseek.png',
}

export const DOUBAO_SEED: ServerDataTypes.Model = {
  ai: true,
  desc: '',
  key: 'doubao-seed-1.6-think',
  level: 2,
  name: 'Doubao-Seed-1.6-Think',
  translate: false,
  type: 'ai',
  version: 'pro',
  icon: 'https://cdn.yiban.io/web/pt-web/model_logo/doubao.png',
}

export const CHAT_GPT_MINI: ServerDataTypes.Model = {
  ai: true,
  desc: '',
  key: 'gpt-4.1-mini',
  level: 2,
  name: 'GPT-4.1 mini',
  translate: true,
  type: 'ai',
  version: 'pro',
  icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gpt.png',
}

export type GlobalModelMap = Record<
  PostDataTypes.UseType,
  {
    freeModel: ServerDataTypes.Model
    vipModel: ServerDataTypes.Model // 保持向后兼容，作为默认VIP模型
    vipModels?: {
      // 新增：分级VIP模型配置
      pro?: ServerDataTypes.Model // Pro会员专用模型
      'pro+'?: ServerDataTypes.Model // 无限会员专用模型
      max?: ServerDataTypes.Model // Max会员专用模型
      ultra?: ServerDataTypes.Model // Ultra会员专用模型
    }
    currentModel: ServerDataTypes.Model
    switchByUser: boolean
  }
>

// 扩展模型选择策略配置
export const MODEL_STRATEGY_CONFIG: GlobalModelMap = {
  normal: {
    freeModel: DEEPL_MODEL,
    vipModel: DEEPL_MODEL, // 默认VIP模型（向后兼容）
    // vipModels: {
    //   // 分级VIP模型配置
    //   pro: DOUBAO_SEED,
    //   'pro+': DEEPSEEK_R1_MODEL,
    //   max: CHAT_GPT_MINI,
    // },
    currentModel: MICROSOFT_MODEL,
    switchByUser: false,
  },
  select: {
    freeModel: DEEPL_MODEL,
    vipModel: DEEPL_MODEL,
    currentModel: MICROSOFT_MODEL,
    switchByUser: false,
  },
  hover: {
    freeModel: DEEPL_MODEL,
    vipModel: DEEPL_MODEL,
    currentModel: MICROSOFT_MODEL,
    switchByUser: false,
  },
  video: {
    freeModel: DEEPL_MODEL,
    vipModel: DEEPL_MODEL,
    currentModel: MICROSOFT_MODEL,
    switchByUser: false,
  },
  chat: {
    freeModel: DEEPSEEK_V3,
    vipModel: DEEPSEEK_V3,
    currentModel: GLM_FLASH_MODEL,
    switchByUser: false,
  },
  focus: {
    freeModel: DEEPSEEK_V3,
    vipModel: DEEPSEEK_V3,
    currentModel: GLM_FLASH_MODEL,
    switchByUser: false,
  },

  web_summary: {
    freeModel: DEEPSEEK_V3,
    vipModel: DEEPSEEK_V3,
    currentModel: GLM_FLASH_MODEL,
    switchByUser: false,
  },
  video_summary: {
    freeModel: DEEPSEEK_V3,
    vipModel: DEEPSEEK_V3,
    currentModel: GLM_FLASH_MODEL,
    switchByUser: false,
  },
  pdf: {
    freeModel: MICROSOFT_MODEL,
    vipModel: DEEPL_MODEL,
    currentModel: MICROSOFT_MODEL,
    switchByUser: false,
  },
  real_time: {
    freeModel: DEEPL_MODEL,
    vipModel: DEEPL_MODEL,
    currentModel: MICROSOFT_MODEL,
    switchByUser: false,
  },
  input_enhance: {
    freeModel: DEEPL_MODEL,
    vipModel: DEEPL_MODEL,
    currentModel: MICROSOFT_MODEL,
    switchByUser: false,
  },
  text_translate: {
    freeModel: DEEPL_MODEL,
    vipModel: DEEPL_MODEL,
    currentModel: MICROSOFT_MODEL,
    switchByUser: false,
  },
}

export const MODEL_ALL: ServerDataTypes.Model[] = [
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/microsoft.png',
    key: 'microsoft',
    level: 1,
    name: '微软翻译',
    translate: true,
    type: 'machine',
    version: 'free',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/zhipu.png',
    key: 'glm-4-flash',
    level: 1,
    name: '智谱GLM-4-Flash',
    translate: true,
    type: 'ai',
    version: 'free',
  },
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepl.png',
    key: 'deepl-classic',
    level: 2,
    name: 'DeepL（经典）',
    translate: true,
    type: 'machine',
    version: 'pro',
  },
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepl.png',
    key: 'deepl-next-new',
    level: 2,
    name: 'DeepL（新一代）',
    translate: true,
    type: 'machine',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepseek.png',
    key: 'deepseek-v3',
    level: 2,
    name: 'DeepSeek V3.2 Exp',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepseek.png',
    key: 'deepseek-r1',
    level: 2,
    name: 'DeepSeek R1',
    translate: false,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/doubao.png',
    key: 'doubao-seed-1.6',
    level: 2,
    name: 'Doubao-Seed-1.6',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/doubao.png',
    key: 'doubao-seed-1.6-think',
    level: 2,
    name: 'Doubao-Seed-1.6-Think',
    translate: false,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/qwen-logo.png',
    key: 'qwen-plus-latest',
    level: 2,
    name: 'Qwen-3-Plus',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/zhipu.png',
    key: 'glm-4.5',
    level: 2,
    name: '智谱GLM-4.5',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gpt.png',
    key: 'gpt-5-mini',
    level: 2,
    name: 'GPT-5 mini',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/claude.png',
    key: 'claude-3.5-haiku',
    level: 2,
    name: 'Claude 3.5 Haiku',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gemini.png',
    key: 'gemini-2.5-flash',
    level: 2,
    name: 'Gemini 2.5 Flash',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/claude.png',
    key: 'claude-4-sonnet',
    level: 3,
    name: 'Claude 4 Sonnet',
    translate: true,
    type: 'ai',
    version: 'ultra',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gpt.png',
    key: 'gpt-5',
    level: 3,
    name: 'GPT-5',
    translate: true,
    type: 'ai',
    version: 'ultra',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gemini.png',
    key: 'gemini-25-pro',
    level: 3,
    name: 'Gemini 2.5 Pro',
    translate: true,
    type: 'ai',
    version: 'ultra',
  },
]

export const MODEL_TRANSLATE: ServerDataTypes.Model[] = [
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/microsoft.png',
    key: 'microsoft',
    level: 1,
    name: '微软翻译',
    translate: true,
    type: 'machine',
    version: 'free',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/zhipu.png',
    key: 'glm-4-flash',
    level: 1,
    name: '智谱GLM-4-Flash',
    translate: true,
    type: 'ai',
    version: 'free',
  },
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepl.png',
    key: 'deepl-classic',
    level: 2,
    name: 'DeepL（经典）',
    translate: true,
    type: 'machine',
    version: 'pro',
  },
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepl.png',
    key: 'deepl-next-new',
    level: 2,
    name: 'DeepL（新一代）',
    translate: true,
    type: 'machine',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepseek.png',
    key: 'deepseek-v3',
    level: 2,
    name: 'DeepSeek V3.2 Exp',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/doubao.png',
    key: 'doubao-seed-1.6',
    level: 2,
    name: 'Doubao-Seed-1.6',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/qwen-logo.png',
    key: 'qwen-plus-latest',
    level: 2,
    name: 'Qwen-3-Plus',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/zhipu.png',
    key: 'glm-4.5',
    level: 2,
    name: '智谱GLM-4.5',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gpt.png',
    key: 'gpt-5-mini',
    level: 2,
    name: 'GPT-5 mini',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/claude.png',
    key: 'claude-3.5-haiku',
    level: 2,
    name: 'Claude 3.5 Haiku',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gemini.png',
    key: 'gemini-2.5-flash',
    level: 2,
    name: 'Gemini 2.5 Flash',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/claude.png',
    key: 'claude-4-sonnet',
    level: 3,
    name: 'Claude 4 Sonnet',
    translate: true,
    type: 'ai',
    version: 'ultra',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gpt.png',
    key: 'gpt-5',
    level: 3,
    name: 'GPT-5',
    translate: true,
    type: 'ai',
    version: 'ultra',
  },
  {
    ai: true,
    desc: '',
    fast_translate: false,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/gemini.png',
    key: 'gemini-25-pro',
    level: 3,
    name: 'Gemini 2.5 Pro',
    translate: true,
    type: 'ai',
    version: 'ultra',
  },
]

export const MODEL_FAST_TRANSLATE: ServerDataTypes.Model[] = [
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/microsoft.png',
    key: 'microsoft',
    level: 1,
    name: '微软翻译',
    translate: true,
    type: 'machine',
    version: 'free',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/zhipu.png',
    key: 'glm-4-flash',
    level: 1,
    name: '智谱GLM-4-Flash',
    translate: true,
    type: 'ai',
    version: 'free',
  },
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepl.png',
    key: 'deepl-classic',
    level: 2,
    name: 'DeepL（经典）',
    translate: true,
    type: 'machine',
    version: 'pro',
  },
  {
    ai: false,
    desc: '',
    fast_translate: true,
    focus: false,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepl.png',
    key: 'deepl-next-new',
    level: 2,
    name: 'DeepL（新一代）',
    translate: true,
    type: 'machine',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/deepseek.png',
    key: 'deepseek-v3',
    level: 2,
    name: 'DeepSeek V3.2 Exp',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/doubao.png',
    key: 'doubao-seed-1.6',
    level: 2,
    name: 'Doubao-Seed-1.6',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/qwen-logo.png',
    key: 'qwen-plus-latest',
    level: 2,
    name: 'Qwen-3-Plus',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
  {
    ai: true,
    desc: '',
    fast_translate: true,
    focus: true,
    icon: 'https://cdn.yiban.io/web/pt-web/model_logo/zhipu.png',
    key: 'glm-4.5',
    level: 2,
    name: '智谱GLM-4.5',
    translate: true,
    type: 'ai',
    version: 'pro',
  },
]
